import { render, staticRenderFns } from "./SBTagMultiselect.vue?vue&type=template&id=25438398&scoped=true&"
import script from "./SBTagMultiselect.vue?vue&type=script&lang=js&"
export * from "./SBTagMultiselect.vue?vue&type=script&lang=js&"
import style0 from "./SBTagMultiselect.vue?vue&type=style&index=0&id=25438398&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25438398",
  null
  
)

export default component.exports